export const historyActions = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  GET_ALL_HISTORY: "GET_ALL_HISTORY",
  DELETE_ALL_HISTORY: "DELETE_ALL_HISTORY",
  ADD_VIDEO_TO_HISTORY: "ADD_VIDEO_TO_HISTORY",
  REMOVE_VIDEO_FROM_HISTORY: "REMOVE_VIDEO_FROM_HISTORY",
};
